import React from 'react';
import PropTypes from 'prop-types';
import styles from './WorkflowCard.module.css';

export const WorkflowCard = ({ ticket, type, onAction }) => {
  const getStatusTag = () => {
    switch(type) {
      case 'intervention':
        return { label: 'Needs Attention', variant: 'danger' };
      case 'proposed':
        return { label: 'Pending Approval', variant: 'warning' };
      case 'completed':
        return { label: 'Closed', variant: 'success' };
      default:
        return { label: 'View', variant: 'secondary' };
    }
  };

  const statusTag = getStatusTag();

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-CA') + ' ' + date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };

  const getSystemTag = (system) => {
    const systemMapping = {
      'SAP': 'sap',
      'Database': 'db', 
      'Infrastructure': 'infra'
    };
    return systemMapping[system] || system.toLowerCase();
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.subheader}>
        <div className={styles.ticketInfo}>
          <span className={styles.ticketId}>{ticket.id}</span>
        </div>
        <div className={styles.actionPackTag}>
          <span className={styles.system}>{getSystemTag(ticket.system)}</span>
        </div>
        </div>
        <span className={`${styles.statusTag} ${styles[statusTag.variant]}`}>
          {statusTag.label}
        </span>
      </div>
      
      <div className={styles.content}>
        <h4 className={styles.title}>{ticket.title}</h4>
        <div className={styles.timestamp}>
          {formatDateTime(ticket.timestamp)}
        </div>
        
        <div className={styles.insight}>
          <div className={styles.insightLabel}>AI Insight</div>
          <div className={styles.insightText}>{ticket.aiInsight}</div>
        </div>
        
      </div>
      
      <div className={styles.actions}>
        <div className={styles.leftActions}>
          {type === 'proposed' && (
            <button 
              className={styles.remediateButton}
              onClick={() => onAction?.(ticket.id, 'remediate', ticket)}
            >
              Remediate
            </button>
          )}
        </div>
        <button 
          className={styles.viewButton}
          onClick={() => onAction?.(ticket.id, 'details', ticket)}
        >
          View
          <div className="view-arrow">→</div>
        </button>
      </div>
    </div>
  );
};

WorkflowCard.propTypes = {
  ticket: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    system: PropTypes.string.isRequired,
    aiInsight: PropTypes.string.isRequired,
    timestamp: PropTypes.string.isRequired,
  }).isRequired,
  type: PropTypes.oneOf(['intervention', 'proposed', 'completed']).isRequired,
  onAction: PropTypes.func
};